/*
 *   File : custom-month-picker.js
 *   Author : https://evoqins.com
 *   Description : Monthly reports page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useState } from 'react';
import { Icon } from '../Icon';

//custom style
import style from "../../Style/Component/input.module.scss";
import { OverLay } from '../Others';


const CustomMonthPicker = (props) => {

    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();

    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(null);
    const [isYearView, setIsYearView] = useState(false);
    const [yearEnd, setYearEnd] = useState(currentYear);

    const [selectedDate, setSelectedDate] = useState(null);
    const [toggle, setToggle] = useState(false);

    useEffect(() => {
        if (props.selected) {
            setSelectedDate(props.selected);
        } else {
            setSelectedDate(null);
        }
    }, [props.selected]);

    const handleMonthClick = (month_index) => {
        setSelectedMonth(month_index);
        let selected = `${months[month_index]} ${selectedYear}`

        setToggle(false);
        props.handleSelect(selected);
    };

    const handleYearClick = (year) => {
        setSelectedYear(year);
        setSelectedMonth(null);
        setIsYearView(false);
    };

    const handlePrevYears = () => {
        setYearEnd((prev) => prev - 12);
    };

    const handleNextYears = () => {
        if (yearEnd + 12 <= currentYear) {
            setYearEnd((prev) => prev + 12);
        } else {
            setYearEnd(currentYear);
        }
    };

    const yearRange = Array.from({ length: 12 }, (_, i) => yearEnd - 11 + i);

    const _handleClear = () => {
        setIsYearView(false);

        setSelectedYear(currentYear);
        setSelectedMonth(new Date().getMonth());
        setIsYearView(false);
        setYearEnd(currentYear);

        props.handleClear();
    };

    return (

        <div className={`${props.wrapperClass} position-relative`}>
            {props.label &&
                <label className={`${props.labelStyle} e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom`}>
                    {props.label}
                    {props.required &&
                        <span className='e-text-carmine-pink'>*</span>
                    }
                </label>
            }

            <div className={`${toggle ? 'e-border-0-5px-blue-violet' : props.error ? 'e-border-0-5px-carmine-pink' : 'e-border-1px-light-purple'}  e-bg-white padding-16px-tb padding-16px-lr  d-flex justify-content-between border-radius-8 cursor-pointer`}
                onClick={() => setToggle(prev => !prev)}>
                {selectedDate !== null ?
                    <>
                        <p className='mb-0 e-primary-font e-font-14 e-text-chinese-black e-font-weight-500 line-height-18px'>
                            {selectedDate}
                        </p>
                        <div onClick={(event) => event.stopPropagation()}>
                            <Icon icon="close"
                                className='cursor-pointer d-flex position-relative '
                                size="16px"
                                onClick={_handleClear} />
                        </div>
                    </>
                    :
                    <>
                        <p className='mb-0 e-text-quick-silver e-primary-font e-font-14 e-font-weight-500 line-height-18px'>
                            Select month
                        </p>
                        <img src={require("../../Assets/Image/Others/calendar.svg").default} />
                    </>
                }
            </div>

            {props.error &&
                <p className={`${style.e_error_message} position-absolute mb-0 e-text-carmine-pink e-primary-font e-font-12 line-height-12px pt-1 e-font-weight-500`}>
                    {props.error}
                </p>
            }

            {toggle &&
                <>
                    <OverLay isOpen={toggle} onClose={() => setToggle(prev => !prev)} />
                    <div className='position-absolute e-bg-white top-80px p-3 border-radius-16 z-index-99' style={{ width: '300px', border: '1px solid #ccc', padding: '16px', borderRadius: '8px' }}
                    >
                        {/* Header */}
                        <div className='text-center mb-2 cursor-pointer e-text-chinese-black e-primary-font e-font-20 e-font-weight-600 line-height-24px'
                            onClick={() => setIsYearView(!isYearView)} >
                            {selectedYear}
                        </div>

                        {isYearView ? (
                            <div>
                                {/* Year navigation */}
                                <div className='d-flex justify-content-between align-items-center mb-2'>
                                    <div className='p-1 cursor-pointer'>
                                        <Icon icon="dropdown"
                                            size={18}
                                            className="e-rotate-90"
                                            onClick={handlePrevYears} />
                                    </div>

                                    <div className='e-text-chinese-black e-primary-font e-font-16 e-font-weight-500 line-height-18px'>{yearRange[0]} - {yearRange[11]}</div>

                                    {yearEnd < currentYear ? (
                                        <div className='p-1 cursor-pointer'>
                                            <Icon icon="dropdown"
                                                size={18}
                                                className="e-rotate-270"
                                                onClick={handleNextYears} />
                                        </div>
                                    ) : (
                                        <div style={{ width: '32px' }}></div>
                                    )}
                                </div>

                                {/* Year grid */}
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                                    {yearRange.map((year) => (
                                        <div
                                            key={year}
                                            className={`${year === selectedYear ? "e-bg-blue-violet e-text-white" : "e-bg-magnolia e-text-chinese-black"} p-2 text-center border-radius-4 cursor-pointer e-primary-font e-font-16 e-font-weight-500 line-height-24px`}
                                            onClick={() => handleYearClick(year)}>
                                            {year}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ) : (
                            // Month grid
                            // <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                            //     {months.map((month, index) => (
                            //         <div
                            //             key={month}
                            //             onClick={() => handleMonthClick(index)}
                            //             className={`${index === selectedMonth ? "e-bg-blue-violet e-text-white" : "e-bg-white e-text-chinese-black"} p-2 text-center border-radius-4 cursor-pointer e-primary-font e-font-16 e-font-weight-500 line-height-24px`}
                            //         >
                            //             {month}
                            //         </div>
                            //     ))}
                            // </div>
                            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '8px' }}>
                                {months.map((month, index) => {
                                    const isFutureMonth =
                                        selectedYear === currentYear && index > currentMonth;

                                    return (
                                        <div key={month}
                                            className={`${index === selectedMonth ? "e-bg-blue-violet e-text-white" : "e-bg-white e-text-chinese-black"}
                                                        ${isFutureMonth ? "opacity-50 pe-none" : "cursor-pointer"}  p-2 text-center border-radius-4   e-primary-font e-font-16 e-font-weight-500 line-height-24px`}
                                            onClick={() => {
                                                if (!isFutureMonth) {
                                                    handleMonthClick(index);
                                                }
                                            }}>
                                            {month}
                                        </div>
                                    );
                                })}
                            </div>

                        )}
                    </div>
                </>
            }
        </div>
    );
};

export default CustomMonthPicker;
